"use client";

// Минимальное объединение классов без зависимостей (clsx/tailwind-merge в пакет не входят).
export function cn(...inputs: Array<string | false | null | undefined>): string {
  return inputs.filter(Boolean).join(" ");
}
